import * as React from 'react'

import Localization from '~/client/src/shared/localization/LocalizationManager'

/**
 * Marks a time belonging to the day after the one it is shown under — the end
 * of a window that runs through midnight. One component so the option list, the
 * field and the row that summarises them cannot drift apart, spacing included.
 */
const NextDayLabel: React.FC = () => (
  <span className="tw:ml-2 tw:text-app-micro tw:text-muted-foreground">
    {Localization.translator.nextDay}
  </span>
)

export default NextDayLabel
